// extracted by mini-css-extract-plugin
export var shake = "_i-1";
export var toastCloseButton = "_i-0";